import type { QueryApi } from "../../api/query";

export function createUseRecentTransactions($api: QueryApi) {
  return function useRecentTransactions() {
    return $api.useQuery("get", "/transactions/recent", {}, {
      staleTime: 25_000,
      refetchInterval: 30_000,
      retry: 3,
    });
  };
}
